import React, { useEffect, useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { array, object, string } from "yup";
import { ProductFormValues } from "src/models/Product.model";
import ProductForm from "../Layouts/ProductForm";
import {
  useAddProductMutation,
  useGetProductByIdQuery,
} from "src/services/ProductService";
import { CircularProgress } from "@mui/material";
import { showToast } from "src/utils/showToaster";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { useNavigate, useParams } from "react-router-dom";

export const formatValueInFlatOrPercent = (
  value: any,
  type: "FLAT" | "PERCENT"
) => {
  return type === "PERCENT" ? `${value}%` : `${value}`;
};
const formatPhone = (phone: string) => {
  if (!phone) return "";
  // non-digit characters hata do (jaise +, - etc.)
  const digits = phone.replace(/\D/g, "");
  // last 10 digits nikaal lo
  return digits.slice(-10);
};
const EditProductFormWrapper = () => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});
  const { productId } = useParams();
  const navigate = useNavigate();
  const { isLoading, isFetching, data } = useGetProductByIdQuery(productId);
  const [addProduct] = useAddProductMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);

  const parseCourierCharges = (
    data?: string[] | null
  ): Array<{ day: string; charge: string }> => {
    if (!Array.isArray(data) || data.length === 0) return [];

    const combined = data.filter(Boolean).join(",");
    if (!combined.trim()) return [];

    return combined
      .split(",")
      .map((item) => {
        const parts = item?.trim().split(":");
        const dayPart = parts?.[0] || "";
        const chargePart = parts?.[1] || "";
        const day = dayPart.trim().split(" ")[0] || "";
        const charge = chargePart.trim() || "";
        return { day, charge };
      })
      .filter((item) => item.day !== "" && item.charge !== "");
  };

  const initialValues: ProductFormValues = {
    productName: items?.productName || "",
    nickname: items?.nickname || "",
    productMrp: items?.productMrp || "0",
    maxDiscount: items?.maxDiscount || "0",
    maxDiscountType: { label: "Flat", value: "FLAT" },

    walletDiscount: items?.walletDiscount || "0",
    walletDiscountType: { label: "Flat", value: "FLAT" },

    referralToPercentage: items?.referralToPercentage || "0",
    referralToPercentageType: { label: "Flat", value: "FLAT" },

    courierCharges: parseCourierCharges(items?.courierCharges || []),

    referralByPercentage: items?.referralByPercentage || "0",
    referralByPercentageType: { label: "Flat", value: "FLAT" },

    varientCode: items?.varientCode || "",
    code: items?.code || "",

    subject: (items?.subject || []).map((sub: any) => ({
      label: sub.subjectName,
      value: sub.subjectId,
    })),
    faculty: (items?.faculty || []).map((fac: any) => ({
      label: fac.facultyName,
      value: fac.facultyId,
    })),

    instituteName: (items?.institute || []).map((fac: any) => ({
      label: fac.instituteName,
      value: fac.instituteId,
    })),
    courseName: { label: items?.courseName, value: items?.courseId },
    levelName: { label: items?.levelName, value: items?.levelId },
    batchType: { label: items?.batchType, value: items?.batchTypeId },
    categoryName: { label: items?.categoryName, value: items?.categoryId },
    groupName: { label: items?.groupName, value: items?.groupId },
    modeName: { label: items?.modeName, value: items?.ModeId },
    moduleName: { label: items?.moduleName, value: items?.moduleId },
    syllabusName: { label: items?.syllabusName, value: items?.syllabusId },

    searchKeyCode: items?.searchKeyCode || "",
    image: items?.image || [],
    gdLink: items?.gdLink || "",
    demoLinks: items?.demoLinks || "",
    demoName: items?.demoName || "",
    viewDemo: items?.viewDemo || "",
    demoLinkIsAvailable:
      items?.demoLinkIsAvailable === true
        ? { label: "Yes", value: "YES" }
        : { label: "No", value: "NO" },

    contactTechnicalSupport: formatPhone(items?.contactTechnicalSupport) || "",
    contactTrackingSupport: formatPhone(items?.contactTrackingSupport) || "",

    additionalRequirement: items?.additionalRequirement || "",
    rank: items?.rank || "",
    detailsAmendments: items?.detailsAmendments || "",
    whyToBuy: items?.whyToBuy || "",
    contactForDoubtSolving: formatPhone(items?.contactForDoubtSolving) || "",
    impDescription: items?.impDescription || "",
    shippingMethod: items?.shippingMethod || "",

    meta: items?.meta || "",
    metaTitle: items?.metaTitle || "",
    imageAltText: items?.imageAltText || "",

    allowedPaymentGateway: (items?.allowedPaymentGateway || []).map(
      (allPayGate: any) => ({
        label: allPayGate,
        value: allPayGate,
      })
    ),

    rating: items?.rating || "",
    remark: items?.remark || "",
    documentToBeProvidedForOrderProcessing:
      items?.documentToBeProvidedForOrderProcessing || "",
    orderGoogleSheetLink: items?.orderGoogleSheetLink || "",
    validityExplanationVidUrl: items?.validityExplanationVidUrl || "",
    productExplanationVideoUrl: items?.productExplanationVideoUrl || "",
    viewExplanationVidUrl: items?.viewExplanationVidUrl || "",
    index: items?.index || "",
    additionalDescription: items?.additionalDescription || "",
    tinyUrl: items?.tinyUrl || "",

    unboxingVidLinks: items?.unboxingVidLinks || [],
    relevantProducts: (items?.relevantProducts || []).map((relPro: any) => ({
      label: relPro.productName,
      value: relPro.code,
    })),
    studentAlsoPurchased: (items?.studentAlsoPurchased || [])?.map(
      (relPro: any) => ({
        label: relPro.productName,
        value: relPro.code,
      })
    ),

    isCombo:
      items?.isCombo === true
        ? { label: "Yes", value: "YES" }
        : { label: "No", value: "NO" },
    isAvailable:
      items?.isAvailable === true
        ? { label: "Yes", value: "YES" }
        : { label: "No", value: "NO" },
    isHidden:
      items?.isHidden === true
        ? { label: "Yes", value: "YES" }
        : { label: "No", value: "NO" },
    importantNotice: items?.importantNotice || "",
    isActive:
      items?.isActive === true
        ? { label: "Yes", value: "YES" }
        : { label: "No", value: "NO" },
    inOffer:
      items?.inOffer === true
        ? { label: "Yes", value: "YES" }
        : { label: "No", value: "NO" },
    noOfViews: items?.noOfViews || "",
    viewCountAs: items?.viewCountAs || "",
    viewExtension: items?.viewExtension || "",
    validity: items?.validity || "",
    validityStartsFrom: items?.validityStartsFrom || "",
    validityExtension: items?.validityExtension || "",
    topicsCovered: items?.topicsCovered || "",
    multipleDemo: items?.multipleDemo || "",
    processingTime: items?.processingTime || "",
    productNotes: items?.productNotes || "",
    additionalOffer: items?.additionalOffer || "",
    language: items?.language || "",
    noOfLectures: items?.noOfLectures || "",
    duration: items?.duration || "",
    studyMaterial: items?.studyMaterial || "",
    attempts: items?.attempts || "",
    batchRecording: items?.batchRecording || "",
    kitContent: items?.kitContent || "",
    lectureRecordingDate: items?.lectureRecordingDate || "",
    videoRunsOn: items?.videoRunsOn || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    productName: string().required("Please enter product name"),
    code: string().required("Please enter product code"),
    varientCode: string().required("Please enter varient code"),
    nickname: string().required("Please enter nick name"),
    batchType: object().required("Please select Batch Type"),
    courseName: object().required("Please select course"),
    levelName: object().required("Please select level name"),
    subject: array()
      .of(object())
      .min(1, "Please select a subject")
      .required("Please select a subject"),
    // courierCharges: array()
    //   .of(object())
    //   .min(1, "Please select a subject")
    //   .required("Please select a subject"),
    instituteName: array()
      .of(object())
      .min(1, "Please select a institute")
      .required("Please select a institute"),
    faculty: array()
      .of(object())
      .min(1, "Please select a faculty")
      .required("Please select a faculty"),
    moduleName: object().required("Please select module"),
    groupName: object().required("Please select group"),
    syllabusName: object().required("Please select syllabus name"),
    rank: string().required("Please enter rank"),
    modeName: object().required("Please select mode name"),
    categoryName: object().required("Please select category name"),
    productMrp: string().required("please enter product MRP"),
    maxDiscount: string()
      .test(
        "test-referral-to-percentage",
        "Must be between 0 and 100",
        (value = "0", context) => {
          if (context.parent?.maxDiscountType.value === "PERCENT") {
            if (Number(value) > 100 || Number(value) < 0) {
              return context.createError({
                message: "Cannot be greater than 100%",
                path: context.path,
              });
            }
            return true;
          }
          return true;
        }
      )
      .required("Please enter Value"),
    walletDiscount: string()
      .test(
        "test-referral-to-percentage",
        "Must be between 0 and 100",
        (value = "0", context) => {
          if (context.parent?.walletDiscountType.value === "PERCENT") {
            if (Number(value) > 100 || Number(value) < 0) {
              return context.createError({
                message: "Cannot be greater than 100%",
                path: context.path,
              });
            }
            return true;
          }
          return true;
        }
      )
      .required("Please enter Value"),
    referralToPercentage: string()
      .test(
        "test-referral-to-percentage",
        "Must be between 0 and 100",
        (value = "0", context) => {
          if (context.parent?.referralToPercentageType.value === "PERCENT") {
            if (Number(value) > 100 || Number(value) < 0) {
              return context.createError({
                message: "Cannot be greater than 100%",
                path: context.path,
              });
            }
            return true;
          }
          return true;
        }
      )
      .required("Please enter Value"),
    referralByPercentage: string()
      .test(
        "test-referral-to-percentage",
        "Must be between 0 and 100",
        (value = "0", context) => {
          if (context.parent?.referralByPercentageType.value === "PERCENT") {
            if (Number(value) > 100 || Number(value) < 0) {
              return context.createError({
                message: "Cannot be greater than 100%",
                path: context.path,
              });
            }
            return true;
          }
          return true;
        }
      )
      .required("Please enter Value"),
    demoLinkIsAvailable: object().required(
      "Please select if demo link is available"
    ),
    isHidden: object().required("Please select hidden option"),
    searchKeyCode: string().required("Please enter search key code"),
    gdLink: string().url("Please enter a valid Google Drive link"),
    demoLinks: string().url("Please enter a valid demo link"),
    demoName: string(),
    viewDemo: string().url("Please enter a valid view demo link"),
    contactTechnicalSupport: string()
      .matches(/^[0-9]+$/, "Only numbers allowed")
      .min(10, "Must be at least 10 digits"),
    contactTrackingSupport: string()
      .matches(/^[0-9]+$/, "Only numbers allowed")
      .min(10, "Must be at least 10 digits"),
    additionalRequirement: string(),
    detailsAmendments: string(),
    whyToBuy: string(),
    contactForDoubtSolving: string()
      .matches(/^[0-9]+$/, "Only numbers allowed")
      .min(10, "Must be at least 10 digits"),
    shippingMethod: string().required("Please enter shipping method"),
    meta: string(),
    metaTitle: string(),
    imageAltText: string(),

    rating: string()
      .typeError("Rating must be a number")
      .min(0, "Rating must be at least 0")
      .max(5, "Rating cannot exceed 5"),
    documentToBeProvidedForOrderProcessing: string(),
    orderGoogleSheetLink: string().url(
      "Please enter a valid Google Sheet link"
    ),
    validityExplanationVidUrl: string().url("Please enter a valid video URL"),
    productExplanationVideoUrl: string().url("Please enter a valid video URL"),
    viewExplanationVidUrl: string().url("Please enter a valid video URL"),
    index: string(),
    tinyUrl: string().url("Please enter a valid tiny url"),
    relevantProducts: array().of(object()),
    // .min(1, "Please select at least one relevant product"),
    studentAlsoPurchased: array().of(object()),
    // .min(1, "Please select at least one product"),
    additionalDescription: string(),
    unboxingVidLinks: array()
      .of(string().url("Invalid video link"))
      .min(1, "Please add at least one unboxing video link"),
    image: array(),
    // .of(string().required("Image is required")),
    // .min(1, "Please upload at least one image"),
    remark: string().nullable(),
    importantNotice: string().required("Please enter important notice"),
  });

  // Handle Submit
  const handleSubmit = (
    values: ProductFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ProductFormValues>
  ) => {
  console.log(values.relevantProducts,values.studentAlsoPurchased)

    const formattedValues = {
      productName: values.productName,
      nickname: values.nickname,
      productMrp: Number(values.productMrp),

      maxDiscount: formatValueInFlatOrPercent(
        values?.maxDiscount,
        values?.maxDiscountType?.value
      ),
      walletDiscount: formatValueInFlatOrPercent(
        values?.walletDiscount,
        values?.walletDiscountType?.value
      ),
      referralToPercentage: formatValueInFlatOrPercent(
        values?.referralToPercentage,
        values?.referralToPercentageType?.value
      ),
      referralByPercentage: formatValueInFlatOrPercent(
        values?.referralByPercentage,
        values?.referralByPercentageType?.value
      ),

      courierCharges: values.courierCharges
        ?.map((c: any) => `${c.day} day: ${c.charge}`)
        .join(", "),

      varientCode: values.varientCode,
      code: values.code,

      subject: values.subject?.map((s: any) => s.label).join(","),
      faculty: values.faculty?.map((f: any) => f.label).join(","),
      institute: values.instituteName?.map((f: any) => f.label).join(","),
      courseName: values.courseName?.label,
      levelName: values.levelName?.label,
      batchType: values.batchType?.label,
      categoryName: values.categoryName?.label,
      groupName: values.groupName?.label,
      modeName: values.modeName?.label,
      moduleName: values.moduleName?.label,
      syllabusName: values.syllabusName?.label,

      searchKeyCode: values.searchKeyCode,

      image: values.image?.map((img: any) => img).join(","),

      gdLink: values.gdLink,
      demoLinks: values.demoLinks,
      demoName: values.demoName,
      viewDemo: values.viewDemo,
      demoLinkIsAvailable: values.demoLinkIsAvailable?.value,

      isCombo: values.isCombo?.value,
      isAvailable: values.isAvailable?.value,
      isHidden: values.isHidden?.value,
      productUrlSlug: "",
      contactTechnicalSupport: values.contactTechnicalSupport,
      contactTrackingSupport: values.contactTrackingSupport,
      additionalRequirement: values.additionalRequirement,
      rank: values.rank,
      detailsAmendments: values.detailsAmendments,
      whyToBuy: values.whyToBuy,
      contactForDoubtSolving: values.contactForDoubtSolving,
      impDescription: values.impDescription,
      shippingMethod: values.shippingMethod,
      meta: values.meta,
      metaTitle: values.metaTitle,
      imageAltText: values.imageAltText,
      rating: Number(values.rating),

      remark: values.remark,

      documentToBeProvidedForOrderProcessing:
        values.documentToBeProvidedForOrderProcessing,
      orderGoogleSheetLink: values.orderGoogleSheetLink,
      validityExplanationVidUrl: values.validityExplanationVidUrl,
      productExplanationVideoUrl: values.productExplanationVideoUrl,
      viewExplanationVidUrl: values.viewExplanationVidUrl,
      index: values.index,
      additionalDescription: values.additionalDescription,
      tinyUrl: values.tinyUrl,

      unboxingVidLinks: values.unboxingVidLinks?.join(","),

      relevantProducts: values.relevantProducts
        ?.map((p: any) => p.value)
        .join(","),
      studentAlsoPurchased: values.studentAlsoPurchased
        ?.map((p: any) => p.value)
        .join(","),

      allowedPaymentGateway: values.allowedPaymentGateway
        ?.map((p: any) => p.value)
        .join(","),
      importantNotice: values.importantNotice,
      isActive: values.isActive?.value,
      inOffer: values.inOffer.value,
      noOfViews: values.noOfViews,
      viewCountAs: values.viewCountAs,
      viewExtension: values.viewExtension,
      validity: values.validity,
      validityStartsFrom: values.validityStartsFrom,
      validityExtension: values.validityExtension,
      topicsCovered: values.topicsCovered,
      multipleDemo: values.multipleDemo,
      processingTime: values.processingTime,
      productNotes: values.productNotes,
      additionalOffer: values.additionalOffer,
      language: values.language,
      noOfLectures: values.noOfLectures,
      duration: values.duration,
      studyMaterial: values.studyMaterial,
      attempts: values?.attempts,
      batchRecording: values?.batchRecording,
      kitContent: values?.kitContent,
      lectureRecordingDate: values?.lectureRecordingDate,
      videoRunsOn: values?.videoRunsOn,
    };
    addProduct(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          navigate("/products");
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <SideNavLayout>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <ProductForm formikProps={formikProps} formType="EDIT" />
          </Form>
        )}
      </Formik>
    </SideNavLayout>
  );
};

export default EditProductFormWrapper;
